module.exports = __webpack_public_path__ + "img/537.87bb2865.png";